import { CommentaryPageStatePresenter } from '@/presentation/presenters/commentary/commentaryPageStatePresenter'
import { CommentaryPageStateViewModel } from '@/presentation/viewmodels/commentary/commentaryPageStateViewModel'

export function useCommentaryPageStatePresenter(
  presenter: CommentaryPageStatePresenter = new CommentaryPageStatePresenter(new CommentaryPageStateViewModel())
) {
  return {
    isPreCommentaryFirstTimeOpendPage: presenter.isPreCommentaryFirstTimeOpendPage,
    isPostCommentaryFirstTimeOpendPage: presenter.isPostCommentaryFirstTimeOpendPage,
    preCommentarySelectedList: presenter.preCommentarySelectedList,
    postCommentarySelectedList: presenter.postCommentarySelectedList,
    preCommentaryList: presenter.preCommentaryList,
    postCommentaryList: presenter.postCommentaryList,
    bindCommentary: presenter.bindCommentary.bind(presenter),
    openCommentaryPage: presenter.openCommentaryPage.bind(presenter)
  }
}
